//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    name: 'sortShow',
    computed: {
        ...mapState({
            filter: ({ filtersStore: {filter} }) => filter,
            queries: ({ resourcesStore: {queries} }) => queries,
        }),
    },
    methods: {
        activateSort: function(name, title) {
            let sortQuery = {
                name: name,
                direction: (this.filter.active && this.filter.sort.title === title && this.filter.sort[name] === 'desc') ? 'asc' : 'desc',
                title: title
            };
            let updateQuery = JSON.parse(JSON.stringify(this.queries.models));
            updateQuery.sort = { [name]: sortQuery.direction };
            updateQuery.pagination.page = 1;

            if (this.filter.active && this.filter.sort.title === title && this.filter.sort[name] === 'asc') {
                this.$store.commit('filtersStore/reset', 'sort');
            } else {
                this.$store.commit('filtersStore/setSort', sortQuery);
            }
            this.$store.commit('resourcesStore/updateQuery', updateQuery);
            this.$store.dispatch('resourcesStore/getResources', updateQuery);
        },

    }
}
